<template>
  <div class="button-container">
    <a :href="link" class="btn-primaryNoIcon" :class="aclass !=='' ? aclass : 'md-primarynoIcon'" v-if="open_as == 'link'" :target="target != '' ? target : '_self'">{{ text }}</a>
    <button class="btn-primaryNoIcon" :class="bclass !=='' ? bclass : 'md-primaryrightIcon'" data-bs-toggle="modal" :data-bs-target="'#'+target" v-if="open_as != 'link'">
      {{ text }} <span v-if="show_btn_icon" class='ph-arrow-right-bold'></span>
    </button>
  </div>
</template>

<script>
export default {
  props: {
    text: { type:String, default:'Button'},
    link: { type:String, default:'javascript:void(0)'},
    aclass: { type: String, default: '' },
    bclass: { type: String, default: '' },
    target: { type:String, default:''},
    open_as: { type: String, default: 'link' },
    show_btn_icon: { type: Boolean, default: true },
  },
}

</script>
